import {createSelector} from '@reduxjs/toolkit';

import {TTableColumnFilters} from 'components/@common/widgets/custom-table/table-column-filter/use-table-column-filter/use-table-column-filter-types';
import {adaptFiltersForRequest} from 'components/@common/widgets/custom-table/table-column-filter/use-table-column-filter/use-table-column-filter-utils';
import {TAppState} from 'store/config/types';
import {selectTableReportOptions} from 'store/slices/table-report-slice/table-report-slice-selectors';

import {TABLE_REPORT_SLICE} from '../table-report-slice-constants';

const rootSelector = (state: TAppState) => state[TABLE_REPORT_SLICE];

export const selectTableReportColumnFiltersData = createSelector(
    createSelector(rootSelector, ({reportOptions}) => reportOptions),
    reportOptions => {
        const {filters} = reportOptions;
        return filters as TTableColumnFilters;
    },
);

export const selectTableReportColumnFiltersDataAdaptedForRequest = createSelector(
    selectTableReportColumnFiltersData, tableColumnFilters => adaptFiltersForRequest(tableColumnFilters),
);

export const selectTableReportSavedColumnFilters = createSelector(
    selectTableReportOptions, reportOptions => reportOptions.savedFilters,
);
